export default "__VITE_ASSET__c5bd75eb__"